export default "__VITE_ASSET__fbrZh2NpoG8Hfco_29d_KA__"